/*!
  * Keyboard navigable owl carousel
  */

 (function ($) {
    'use strict';

    $.fn.owlTabbing = function () {
        $(this).each(function() {
            var $carousel = $(this);

            // Initialize the slider
            $carousel
                .on('translate.owl.carousel', function() {
                    $carousel.addClass('owl-transitioning');
                })
                .on('translated.owl.carousel', function() {
                    $carousel
                        .removeClass('owl-transitioning')
                        .find('button.disabled')
                        .attr('tabindex', '-1')
                        .blur()
                        .end()
                        .find('button:not(.disabled)')
                        .removeAttr('tabindex');
                });

            // Remove disabled button from tabindex
            $carousel
                .find('button.disabled')
                .attr('tabindex', '-1');

            var prevButton = $carousel.find('.owl-prev');
            var nextButton = $carousel.find('.owl-next');

            // Remove improper role attributes on next/prev buttons
            prevButton.removeAttr('role');
            nextButton.removeAttr('role');

            // Move prev arrow to the beginning of the box slider
            prevButton.prependTo($carousel);

            // Move next arrow to the end of the box slider
            var owlDots = $carousel.find('.owl-dots:not(.disabled)');
            if (owlDots.length) {
                nextButton.insertBefore(owlDots);
            } else {
                nextButton.appendTo($carousel);
            }

            var owlCount = 1;
            owlDots.find('.owl-dot').each(function() {
                $(this)
                    .attr('aria-label', 'Slide ' + owlCount)
                    .attr('tabindex', '-1');
                owlCount++;
            });

            owlDots
                .wrap('<div>')
                .parent()
                .closest('div')
                .addClass('owl-controls');

            // Prevent tabbing into slider while transitioning
            prevButton.on('keydown', function(e) {
                if (e.which === 9 && $carousel.hasClass('owl-transitioning')) {
                    e.preventDefault();
                }
            });

            // Prevent shift+tabbing into slider while transitioning
            nextButton.on('keydown', function(e) {
                if (e.which === 9 && e.shiftKey && $carousel.hasClass('owl-transitioning')) {
                    e.preventDefault();
                }
            });

            // If only one slide, add class
            if ($carousel.find('.owl-nav').hasClass('disabled')) {
                prevButton.remove();
                nextButton.remove();
            }
        });
    };
}(jQuery));
